import { inject, Injectable } from '@angular/core';
import { combineLatest, map, shareReplay } from 'rxjs';
import { AppConfigService } from '../app-config.service';
import { StubAccessService } from '../core/access';

@Injectable({ providedIn: 'root' })
export class CRMAccessService {
  private readonly appConfigService = inject(AppConfigService);
  private readonly accessService = inject(StubAccessService);

  private readonly viewAccess$ = this.accessService.hasAccessToViews(['partner-views']).pipe(shareReplay(1));

  readonly hasPartnerPermissions$ = this.viewAccess$.pipe(
    map((access) => access[0]),
    shareReplay(1),
  );

  readonly canViewAllCampaigns$ = combineLatest([this.hasPartnerPermissions$, this.appConfigService.config$]).pipe(
    map(([adminView, config]) => adminView && (config.isSuperAdmin || config.userCanAccessMarketing)),
    shareReplay(1),
  );

  readonly canModifyAutomations$ = combineLatest([this.hasPartnerPermissions$, this.appConfigService.config$]).pipe(
    map(([adminView, config]) => adminView && (config.isSuperAdmin || config.userCanAccessAutomations)),
    shareReplay(1),
  );

  //todo SNP-2854: fix access check
  readonly canAccessSales$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessSales || true),
  );

  //todo SNP-2854: fix access check
  readonly canAccessOrders$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessOrders || true),
  );

  //todo SNP-2854: fix access check
  readonly canAccessAutomations$ = this.appConfigService.config$.pipe(
    map((config) => config.isSuperAdmin || config.userCanAccessAutomations || true),
  );
}
